module.exports = __webpack_public_path__ + "img/england.467be391.svg";